
















import Vue from "vue";
import PageHeading from "../components/PageHeading.vue";

export default Vue.extend({
  name: "OpenBankingFailed",
  components: { PageHeading },
  data() {
    return {
      market: this.$route.params.market,
    };
  },
  watch: {
    market: {
      immediate: true,
      handler(market) {
        if (market === "nl") {
          this.$root.$i18n.locale = "nl";
        } else if (market === "uk") {
          this.$root.$i18n.locale = "en";
        }
      },
    },
  },
  methods: {
    close() {
      window.close();
    },
  },
});
